/* eslint-disable max-lines */

import { DeviceType } from '@src/types/devices/Device.types';
import {
  DeviceListDeviceRefsAll,
  WidgetConfigCreateOrEdit,
  WidgetTypes,
} from '@src/types/Widget';

const widgets: WidgetConfigCreateOrEdit[] = [
  {
    internalId: 'meterPoints',
    isSystemWidget: true,
    name: 'Meter',
    header: 'Meter',
    type: WidgetTypes.POINT_LIST,
    pointConfigRefs: [
      [
        {
          pointAlias: 'meter_active_power',
        },
        {
          pointAlias: 'site_meter_reactive_power',
        },
        {
          pointAlias: 'meter_apparent_power',
        },
        {
          pointAlias: 'meter_power_factor',
        },
        {
          pointAlias: 'site_meter_voltage',
        },
        {
          pointAlias: 'meter_current',
        },
        {
          pointAlias: 'site_meter_frequency',
        },
      ],
    ],
  },
  {
    internalId: 'systemPointsList',
    isSystemWidget: true,
    name: 'System Points',
    header: 'System',
    type: WidgetTypes.POINT_LIST,
    pointConfigRefs: [
      [
        {
          pointAlias: 'sys_status',
        },
        {
          pointAlias: 'sys_mode',
        },
        {
          pointAlias: 'sys_unitsonline',
        },
        {
          pointAlias: 'sys_racksonline',
        },
        {
          pointAlias: 'sys_availdchg',
        },
        {
          pointAlias: 'sys_p_command',
        },
        {
          pointAlias: 'sys_q_command',
        },
        {
          pointAlias: 'sys_rtac_p',
        },
        {
          pointAlias: 'sys_rtac_q',
        },
        {
          pointAlias: 'sys_allowed_max_q',
        },
        {
          pointAlias: 'sys_allowed_min_q',
        },
        {
          pointAlias: 'sys_ads_flg',
        },
      ],
    ],
  },
  {
    internalId: 'teslaSystemPointsList',
    isSystemWidget: true,
    name: 'Tesla System Points',
    header: 'System',
    type: WidgetTypes.POINT_LIST,
    pointConfigRefs: [
      [
        {
          pointAlias: 'sys_status',
        },
        {
          pointAlias: 'sys_mode',
        },
        {
          pointAlias: 'sys_unitsonline',
        },
        {
          pointAlias: 'sys_racksonline',
        },
        {
          pointAlias: 'sys_availdchg',
        },
        {
          pointAlias: 'sys_p_command',
        },
        {
          pointAlias: 'sys_q_command',
        },
        {
          pointAlias: 'sys_rtac_p',
        },
        {
          pointAlias: 'sys_rtac_q',
        },
        {
          pointAlias: 'sys_allowed_max_q',
        },
        {
          pointAlias: 'sys_allowed_min_q',
        },
        {
          pointAlias: 'sys_ads_flg',
        },
      ],
    ],
  },
  {
    internalId: 'pvSystemPointsList',
    isSystemWidget: true,
    name: 'PV System Points',
    header: 'System',
    type: WidgetTypes.POINT_LIST,
    pointConfigRefs: [
      [
        {
          pointAlias: 'sys_status',
        },
        {
          pointAlias: 'sys_mode',
        },
        {
          pointAlias: 'sys_unitsonline',
        },
        {
          pointAlias: 'sys_racksonline',
        },
        {
          pointAlias: 'sys_availdchg',
        },
        {
          pointAlias: 'sys_p_command',
        },
        {
          pointAlias: 'sys_q_command',
        },
        {
          pointAlias: 'sys_rtac_p',
        },
        {
          pointAlias: 'sys_rtac_q',
        },
        {
          pointAlias: 'sys_allowed_max_q',
        },
        {
          pointAlias: 'sys_allowed_min_q',
        },
        {
          pointAlias: 'sys_ads_flg',
        },
      ],
    ],
  },
  {
    internalId: 'site_SOC',
    isSystemWidget: true,
    name: 'Site SOC',
    header: 'SOC',
    type: WidgetTypes.POINT_LIST,
    pointConfigRefs: [
      [
        {
          pointAlias: 'site_soc',
        },
      ],
    ],
  },
  {
    name: 'MP List',
    internalId: 'mpList',
    isSystemWidget: true,
    type: WidgetTypes.DEVICE_LIST,
    deviceRefs: DeviceListDeviceRefsAll.ALL,
    deviceType: DeviceType.METER_POINT,
    pointConfigRefs: [
      {
        pointAlias: 'megapack_disabled',
      },
      {
        pointAlias: 'ac_breaker_status',
      },
      {
        pointAlias: 'loss_of_megapack_communication',
      },
      {
        pointAlias: 'megapack_real_power',
      },
      {
        pointAlias: 'megapack_reactive_power',
      },
      {
        pointAlias: 'megapack_state_of_energy',
      },
    ],
  },
  {
    name: 'TSC List',
    internalId: 'tscList',
    isSystemWidget: true,
    type: WidgetTypes.DEVICE_LIST,
    deviceRefs: DeviceListDeviceRefsAll.ALL,
    deviceType: DeviceType.TSC,
    pointConfigRefs: [
      {
        pointAlias: 'meter_real_power',
      },
      {
        pointAlias: 'meter_reactive_power',
      },
      {
        pointAlias: 'remaining_battery_energy',
      },
      {
        pointAlias: 'number_of_available_megapacks',
      },
    ],
  },
  {
    name: 'Unit Controllers List',
    internalId: 'unitList',
    isSystemWidget: true,
    type: WidgetTypes.DEVICE_LIST,
    deviceRefs: DeviceListDeviceRefsAll.ALL,
    deviceType: DeviceType.UNIT_CONTROLLER,
    pointConfigRefs: [
      {
        pointAlias: 'AC_Breaker',
      },
      {
        pointAlias: 'kW',
      },
      {
        pointAlias: 'kVAR',
      },
      {
        pointAlias: 'racks_online',
      },
      {
        pointAlias: 'max_amb_t',
      },
      {
        pointAlias: 'max_cell_t',
      },
      {
        pointAlias: 'ac_breaker',
      },
      {
        pointAlias: 'dc_disconnect',
      },
      {
        pointAlias: 'hvac_status_unit_state',
      },
      {
        pointAlias: 'fan_status',
      },
      {
        pointAlias: 'lo_co_alarm',
      },
      {
        pointAlias: 'lo_hydrogen_alarm',
      },
      {
        pointAlias: 'hi_hydrogen_alarm',
      },
      {
        pointAlias: 'vesda_fire_alarm',
      },
      {
        pointAlias: 'vesda_action',
      },
      {
        pointAlias: 'fa_discharge_alarm',
      },
    ],
  },
  {
    name: 'TSC Details',
    internalId: 'tscDetails',
    isSystemWidget: true,
    type: WidgetTypes.POINT_LIST,
    pointConfigRefs: [
      [
        {
          pointAlias: 'state_request',
        },
        {
          pointAlias: 'number_of_available_megapacks',
        },
        {
          pointAlias: 'remaining_battery_energy',
        },
        {
          pointAlias: 'dispatchable_charge_power',
        },
        {
          pointAlias: 'dispatchable_discharge_power',
        },
      ],
      [
        {
          pointAlias: 'meter_real_power',
        },
        {
          pointAlias: 'meter_reactive_power',
        },
        {
          pointAlias: 'battery_direct_real_power_command',
        },
      ],
      [
        {
          pointAlias: 'meter_voltage',
        },
        {
          pointAlias: 'meter_frequency',
        },
        {
          pointAlias: 'battery_direct_reactive_power_command',
        },
      ],
    ],
  },
  {
    name: 'MP Details Modal',
    internalId: 'mpDetailsModal',
    isSystemWidget: true,
    type: WidgetTypes.MULTI_SECTION_POINT_LIST,
    sections: [
      {
        title: 'Status',
        pointConfigRefs: [
          [
            {
              pointAlias: 'megapack_disabled',
            },
            {
              pointAlias: 'ac_breaker_status',
            },
            {
              pointAlias: 'loss_of_megapack_communication',
            },
          ],
          [
            {
              pointAlias: 'megapack_state_of_energy',
            },
            {
              pointAlias: 'megapack_real_power',
            },
            {
              pointAlias: 'megapack_reactive_power',
            },
            {
              pointAlias: 'megapack_real_power_target',
            },
            {
              pointAlias: 'megapack_reactive_power_target',
            },
            {
              pointAlias: 'megapack_available_charge_power',
            },
            {
              pointAlias: 'megapack_available_discharge_power',
            },
          ],
        ],
      },
      {
        title: 'Meter',
        pointConfigRefs: [
          [
            {
              pointAlias: 'megapack_frequency',
            },
            {
              pointAlias: 'megapack_ac_voltage',
            },
            {
              pointAlias: 'megapack_phase_a_voltage',
            },
            {
              pointAlias: 'megapack_phase_b_voltage',
            },
            {
              pointAlias: 'megapack_phase_c_voltage',
            },
          ],
          [
            {
              pointAlias: 'megapack_phase_a_current',
            },
            {
              pointAlias: 'megapack_phase_b_current',
            },
            {
              pointAlias: 'megapack_phase_c_current',
            },
          ],
        ],
      },
      {
        title: 'Temperature',
        pointConfigRefs: [
          [
            {
              pointAlias: 'maximum_battery_temperature',
            },
          ],
          [
            {
              pointAlias: 'ambient_temperature',
            },
          ],
        ],
      },
    ],
  },
  {
    name: 'Incident Command',
    internalId: 'incidentCommandList',
    isSystemWidget: true,
    type: WidgetTypes.DEVICE_LIST,
    header: 'Incident Command',
    deviceRefs: DeviceListDeviceRefsAll.ALL,
    deviceType: DeviceType.UNIT_CONTROLLER,
    pointConfigRefs: [
      {
        pointAlias: 'ic_bms1_avg_cell_v',
        overrideSourceDeviceId: 'bms_1',
      },
      {
        pointAlias: 'ic_bms2_avg_cell_t',
        overrideSourceDeviceId: 'bms_2',
      },
      {
        pointAlias: 'min_amb_t',
      },
      {
        pointAlias: 'avg_amb_t',
      },
      {
        pointAlias: 'max_amb_t',
      },
      {
        pointAlias: 'max_cell_t',
      },
      {
        pointAlias: 'ac_breaker',
      },
      {
        pointAlias: 'dc_disconnect',
      },
      {
        pointAlias: 'hvac_status_unit_state',
      },
      {
        pointAlias: 'fan_status',
      },
      {
        pointAlias: 'lo_co_alarm',
      },
      {
        pointAlias: 'lo_hydrogen_alarm',
      },
      {
        pointAlias: 'hi_hydrogen_alarm',
      },
      {
        pointAlias: 'vesda_fire_alarm',
      },
      {
        pointAlias: 'vesda_action',
      },
      {
        pointAlias: 'fa_discharge_alarm',
      },
    ],
  },
];

export default widgets;
